{
  "infoOptions": {
    "statistics": {
      "statistics": "Статистика",
      "avgPrice": "Ср. цена",
      "openPrice": "Открытие",
      "closePrice": "Закрытие",
      "beforeClose": "Пред. закр.",
      "lastTrade": "Пред. сделка",
      "maxDay": "Макс. за день",
      "minDay": "Мин. за день",
      "openInterest": "Откр. интерес",
      "implVolatility": "Имп. вол.",
      "volumePerDay": "Объём за день"
    },
    "greek": {
      "greek": "Греки",
      "delta": "Delta",
      "theta": "Theta",
      "gamma": "Gamma",
      "vega": "Vega"
    },
    "description": "Отображаемая статистика по опционам представляет собой индикативные цены от нашего поставщика рыночных данных. Цены исполнения для рыночных ордеров могут отличаться от отображаемых индикативных котировок.",
    "notHaveOption": "Выберите опцион, чтобы посмотреть информацию"
  }
}
